
import { Component, Vue } from 'vue-property-decorator'
import ConfirmPasswordDialog from '@/views/contract/template/ConfirmPasswordDialog.vue'
import { backToBefore } from '@/utils/h5ToApp'
import { Getter } from 'vuex-class'

@Component({
  name: 'LogOff',
  components: {ConfirmPasswordDialog}
})

export default class LogOff extends Vue {
  @Getter info: any // 用户信息
  applyLogOff () {
    if (this.info.isIdentification == 1 && this.info.userOtherType == 1) {
      this.$dialog.alert({
        message: '您已认证为当前公司的法定代表人，如需注销账号，请联系我司工作人员。',
      }).then(() => {
        // on close
      })
    } else {
      (this.$refs.confirmPasswordDialog as any).show()
    }
  }

  handleBack () {
    backToBefore()
  }
}
